// src/components/layout/Header.js

import React from "react";
import { Link } from "gatsby";
import Logo from '../partials/Logo';
import Countdown from '../partials/Countdown';

const Header = ({ data, videoList, noButton }) => {
  const isNomination = typeof window !== 'undefined' && window.location.pathname.includes('/nomination/invite');

  return (
    <header className={videoList ? "videoList" : "nominate"}>
      <div className="grid grid-cols-12 h-full items-center">
        <div className="col-span-6 md:col-span-3 lg:col-span-4">
          <Logo />
        </div>
        <div className="col-span-6 md:col-span-9 lg:col-span-8 flex justify-end gap-3 lg:gap-10">
          <div className="basis-8/12">
            {data.strapiMotSetting.countdown && (
              <Countdown data={data} targetDate={data.strapiMotSetting.countdownDate} />
            )}
          </div>
          {!isNomination && !noButton && (
            <>
              {data.strapiMotSetting.headerBtn && (
                <div className="hidden sm:block text-center whitespace-nowrap">
                  <Link className="primary" to={data.strapiMotSetting.headerBtnLink}>
                    {data.strapiMotSetting.headerBtnText}
                  </Link>
                </div>
              )}
            </>
          )}
          {/* Add Blog Link 
          <Link
            to="/blog"
            className="primary"
          >
            Blog
          </Link>*/}
        </div>
      </div>
    </header>
  );
};

export default Header;
